import type { Reward } from "@/mocks/artistData";

export type ScheduleStatus = "upcoming" | "active" | "expired";

/** 오늘 날짜 기준으로 리워드 제공 상태를 반환 */
export function getScheduleStatus(reward: Reward): ScheduleStatus {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const start = new Date(reward.startDate);
  const end = new Date(reward.endDate);
  end.setHours(23, 59, 59, 999);

  if (today < start) return "upcoming";
  if (today > end) return "expired";
  return "active";
}

/** D-Day 또는 D+Day 문자열 반환 */
export function getDDay(reward: Reward): string {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const end = new Date(reward.endDate);
  end.setHours(0, 0, 0, 0);
  const diff = Math.ceil((end.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));

  if (diff === 0) return "D-Day";
  if (diff > 0) return `D-${diff}`;
  return `종료 ${Math.abs(diff)}일 전`;
}

/** 오픈까지 남은 일수 */
export function getDaysUntilOpen(reward: Reward): number {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const start = new Date(reward.startDate);
  start.setHours(0, 0, 0, 0);
  return Math.ceil((start.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
}

/** YYYY-MM-DD → YYYY.MM.DD 표기 변환 */
export function formatDate(iso: string): string {
  return iso.replace(/-/g, ".");
}

/** 리워드가 교환 가능한 상태인지 (active + 재고 있음) */
export function isRedeemable(reward: Reward): boolean {
  return getScheduleStatus(reward) === "active" && reward.stock > 0;
}
